
  import { Component, Vue, Prop } from 'vue-property-decorator';
  import { Getter, Action } from 'vuex-class';
  import { GetFlag } from '../..';
  
  @Component({
    name: 'RephraseTester'
  })
  export default class RephraseTester extends Vue {
    @Prop({ required: true }) promptId!: string;
    @Action('rephrase', { namespace: 'rephrase' }) rephrase!: any;
    @Getter('langs', { namespace: 'rephrase' }) langs!: string[];
  
    text: string = '';
    result: string = '';
    loading: boolean = false;
    lang: string = 'fr';
    GetFlag = GetFlag;
  
    async submitRephrase() {
      this.loading = true; // Start loading
      try {
        const response = await this.rephrase({ text: this.text, lang: this.lang, promptId: this.promptId, tryAgain: false });
        if(response.requestError){
          console.error('Error rephrasing text:', response.requestError);
          this.result = response.requestError.data.detail;
        }else{
          this.result = response;
        }
      } catch (error) {
        console.error('Error rephrasing text:', error);
      } finally {
        this.loading = false; // Stop loading
      }
    }
  }
  